export default "__VITE_ASSET__D1qskv9f__"